import { cn } from "@/utils/cn";

export interface CardProps {
  className?: string;
  children: React.ReactNode;
}

export function Card({ className, children }: CardProps) {
  return (
    <div
      className={cn(
        "overflow-hidden rounded-xl border border-healthsource-lightLavender bg-white shadow-sm",
        className
      )}
      style={{ boxShadow: "0 2px 8px rgba(30,37,43,0.06)" }}
    >
      {children}
    </div>
  );
}

export interface CardHeaderProps {
  className?: string;
  children: React.ReactNode;
  action?: React.ReactNode;
}

export function CardHeader({ className, children, action }: CardHeaderProps) {
  return (
    <div
      className={cn(
        "flex min-w-0 max-w-full items-center justify-between gap-2 px-3 py-3 sm:px-5",
        className
      )}
    >
      <h2 className="min-w-0 flex-1 truncate text-[15px] font-extrabold text-healthsource-dark">
        {children}
      </h2>
      {action ? <div className="min-w-0 shrink-0">{action}</div> : null}
    </div>
  );
}
